import React, {useEffect} from 'react';
import {createMuiTheme, makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import VolumeDown from '@material-ui/icons/VolumeDown';
import VolumeUp from '@material-ui/icons/VolumeUp';
import { ThemeProvider } from "@material-ui/styles";
import {VolumeMute, VolumeOff} from "@material-ui/icons";
import {IconButton} from "@material-ui/core";
import ClosedCaptionIcon from "@material-ui/icons/ClosedCaption";
import Toolbar from "@material-ui/core/Toolbar";
const useStyles = makeStyles({
    root: {
        width: "auto",
    },
    slider: {
        height:100,
        flexDirection:"column",
        display:"flex",
        position:"absolute",
        bottom:50,
        left:18
    }
});
const muiTheme = createMuiTheme({
    overrides: {
        MuiSlider: {
            thumb: {
                color: "pink"
            },
            track: {
                background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)"
            },
            rail: {
                color: "black"
            }
        }
    }
});
export default function ClosedCaptionButton(props) {
    const classes = useStyles();
    const [active, setActive] = React.useState<number>(props.active);

    useEffect(() => {
            setActive(props.active);
    }, [props.active]);

    const handleClick = () => {
        if (props.onClick) {
            props.onClick();
        }
    }

    let color:string = "inherit";
    if(active && !props.disabled) {
        color = "secondary"
    } else if (props.disabled){
        color = "disabled"
    }
    return (
        <IconButton
            onClick={handleClick}
            color={color}
            aria-label="Closed Captions"
            aria-pressed={active}
        >
            <ClosedCaptionIcon />
        </IconButton>
    );
}
